import { LANDING_PAGES, type LandingPageKey } from "@/lib/landingPages";
import { SITE_URL } from "@/lib/site-url";

/**
 * Metadatos SSR (title/description/og/canonical) para las páginas dedicadas
 * de secciones. Se emiten desde el `head()` de cada ruta para que estén en el
 * HTML servido sin ejecutar JS.
 */
export function landingHead(section: LandingPageKey, lang: "es" | "en") {
  const copy = LANDING_PAGES[section];
  const path = lang === "es" ? copy.pathEs : copy.pathEn;
  const title = copy.title[lang];
  const description = copy.description[lang];
  const url = `${SITE_URL}${path}`;

  return {
    meta: [
      { title },
      { name: "description", content: description },
      { name: "keywords", content: copy.keywords[lang] },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: lang === "es" ? "es_ES" : "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:url", content: url },
      // La consulta con el agente vive en /agente-retail-ia: esta página de
      // presentación se mantiene accesible pero no compite en buscadores.
      ...(section === "aiAgent" ? [{ name: "robots", content: "noindex, follow" }] : []),
    ],
    // El canonical y los hreflang los emite <SEO /> desde la propia página,
    // así evitamos duplicar <link rel="canonical">.
  };
}

